/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PhongNhaRouteRouteImport } from './routes/phong-nha/route'
import { Route as LayoutRouteRouteImport } from './routes/_layout/route'
import { Route as PhongNhaIndexRouteImport } from './routes/phong-nha/index'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as PhongNhaSearchRouteImport } from './routes/phong-nha/search'
import { Route as PhongNhaCheckoutRouteImport } from './routes/phong-nha/checkout'
import { Route as LayoutSelectTrainRouteImport } from './routes/_layout/select-train'
import { Route as LayoutSearchRouteImport } from './routes/_layout/search'
import { Route as LayoutCheckoutRouteImport } from './routes/_layout/checkout'
import { Route as PhongNhaThueAoDaiIndexRouteImport } from './routes/phong-nha/thue-ao-dai/index'
import { Route as PhongNhaQuaLuuNiemIndexRouteImport } from './routes/phong-nha/qua-luu-niem/index'
import { Route as PhongNhaOrdersIndexRouteImport } from './routes/phong-nha/orders/index'
import { Route as PhongNhaLoyaltyIndexRouteImport } from './routes/phong-nha/loyalty/index'
import { Route as PhongNhaCustomerIndexRouteImport } from './routes/phong-nha/customer/index'
import { Route as PhongNhaCategoryIndexRouteImport } from './routes/phong-nha/category/index'
import { Route as PhongNhaAuthIndexRouteImport } from './routes/phong-nha/auth/index'
import { Route as LayoutOrdersIndexRouteImport } from './routes/_layout/orders/index'
import { Route as LayoutLoyaltyIndexRouteImport } from './routes/_layout/loyalty/index'
import { Route as LayoutCustomerIndexRouteImport } from './routes/_layout/customer/index'
import { Route as LayoutCategoryIndexRouteImport } from './routes/_layout/category/index'
import { Route as LayoutAuthIndexRouteImport } from './routes/_layout/auth/index'
import { Route as PhongNhaOrdersResultRouteImport } from './routes/phong-nha/orders/result'
import { Route as PhongNhaOrdersIdRouteImport } from './routes/phong-nha/orders/$id'
import { Route as PhongNhaO2oCustomerBookTableRouteImport } from './routes/phong-nha/o2o/customer-book-table'
import { Route as PhongNhaLoyaltyVouchersRouteImport } from './routes/phong-nha/loyalty/vouchers'
import { Route as PhongNhaLoyaltyRewardRouteImport } from './routes/phong-nha/loyalty/reward'
import { Route as PhongNhaLoyaltyPointsRouteImport } from './routes/phong-nha/loyalty/points'
import { Route as PhongNhaLoyaltyMembershipPrivilegesRouteImport } from './routes/phong-nha/loyalty/membership-privileges'
import { Route as PhongNhaLoyaltyIdRouteImport } from './routes/phong-nha/loyalty/$id'
import { Route as PhongNhaCategoryIdRouteImport } from './routes/phong-nha/category/$id'
import { Route as PhongNhaAuthLoginRouteImport } from './routes/phong-nha/auth/login'
import { Route as LayoutStoresSelectStoreRouteImport } from './routes/_layout/stores/select-store'
import { Route as LayoutStoresIdRouteImport } from './routes/_layout/stores/$id'
import { Route as LayoutOrdersResultRouteImport } from './routes/_layout/orders/result'
import { Route as LayoutOrdersIdRouteImport } from './routes/_layout/orders/$id'
import { Route as LayoutO2oCustomerBookTableRouteImport } from './routes/_layout/o2o/customer-book-table'
import { Route as LayoutLoyaltyVouchersRouteImport } from './routes/_layout/loyalty/vouchers'
import { Route as LayoutLoyaltyRewardRouteImport } from './routes/_layout/loyalty/reward'
import { Route as LayoutLoyaltyPointsRouteImport } from './routes/_layout/loyalty/points'
import { Route as LayoutLoyaltyMembershipPrivilegesRouteImport } from './routes/_layout/loyalty/membership-privileges'
import { Route as LayoutLoyaltyIdRouteImport } from './routes/_layout/loyalty/$id'
import { Route as LayoutCategoryIdRouteImport } from './routes/_layout/category/$id'
import { Route as LayoutAuthLoginRouteImport } from './routes/_layout/auth/login'
import { Route as PhongNhaGuestOrdersIndexRouteImport } from './routes/phong-nha/guest/orders/index'
import { Route as PhongNhaCustomerAddressIndexRouteImport } from './routes/phong-nha/customer/address/index'
import { Route as LayoutGuestOrdersIndexRouteImport } from './routes/_layout/guest/orders/index'
import { Route as LayoutCustomerAddressIndexRouteImport } from './routes/_layout/customer/address/index'
import { Route as PhongNhaGuestOrdersResultRouteImport } from './routes/phong-nha/guest/orders/result'
import { Route as PhongNhaGuestOrdersIdRouteImport } from './routes/phong-nha/guest/orders/$id'
import { Route as PhongNhaCustomerAddressCreateRouteImport } from './routes/phong-nha/customer/address/create'
import { Route as LayoutGuestOrdersResultRouteImport } from './routes/_layout/guest/orders/result'
import { Route as LayoutGuestOrdersIdRouteImport } from './routes/_layout/guest/orders/$id'
import { Route as LayoutCustomerAddressCreateRouteImport } from './routes/_layout/customer/address/create'

const PhongNhaRouteRoute = PhongNhaRouteRouteImport.update({
  id: '/phong-nha',
  path: '/phong-nha',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRouteRoute = LayoutRouteRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const PhongNhaIndexRoute = PhongNhaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const PhongNhaSearchRoute = PhongNhaSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaCheckoutRoute = PhongNhaCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const LayoutSelectTrainRoute = LayoutSelectTrainRouteImport.update({
  id: '/select-train',
  path: '/select-train',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutSearchRoute = LayoutSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCheckoutRoute = LayoutCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const PhongNhaThueAoDaiIndexRoute = PhongNhaThueAoDaiIndexRouteImport.update({
  id: '/thue-ao-dai/',
  path: '/thue-ao-dai/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaQuaLuuNiemIndexRoute = PhongNhaQuaLuuNiemIndexRouteImport.update({
  id: '/qua-luu-niem/',
  path: '/qua-luu-niem/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaOrdersIndexRoute = PhongNhaOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaLoyaltyIndexRoute = PhongNhaLoyaltyIndexRouteImport.update({
  id: '/loyalty/',
  path: '/loyalty/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaCustomerIndexRoute = PhongNhaCustomerIndexRouteImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaCategoryIndexRoute = PhongNhaCategoryIndexRouteImport.update({
  id: '/category/',
  path: '/category/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaAuthIndexRoute = PhongNhaAuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const LayoutOrdersIndexRoute = LayoutOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutLoyaltyIndexRoute = LayoutLoyaltyIndexRouteImport.update({
  id: '/loyalty/',
  path: '/loyalty/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCustomerIndexRoute = LayoutCustomerIndexRouteImport.update({
  id: '/customer/',
  path: '/customer/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCategoryIndexRoute = LayoutCategoryIndexRouteImport.update({
  id: '/category/',
  path: '/category/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutAuthIndexRoute = LayoutAuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const PhongNhaOrdersResultRoute = PhongNhaOrdersResultRouteImport.update({
  id: '/orders/result',
  path: '/orders/result',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaOrdersIdRoute = PhongNhaOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaO2oCustomerBookTableRoute =
  PhongNhaO2oCustomerBookTableRouteImport.update({
    id: '/o2o/customer-book-table',
    path: '/o2o/customer-book-table',
    getParentRoute: () => PhongNhaRouteRoute,
  } as any)
const PhongNhaLoyaltyVouchersRoute = PhongNhaLoyaltyVouchersRouteImport.update({
  id: '/loyalty/vouchers',
  path: '/loyalty/vouchers',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaLoyaltyRewardRoute = PhongNhaLoyaltyRewardRouteImport.update({
  id: '/loyalty/reward',
  path: '/loyalty/reward',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaLoyaltyPointsRoute = PhongNhaLoyaltyPointsRouteImport.update({
  id: '/loyalty/points',
  path: '/loyalty/points',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaLoyaltyMembershipPrivilegesRoute =
  PhongNhaLoyaltyMembershipPrivilegesRouteImport.update({
    id: '/loyalty/membership-privileges',
    path: '/loyalty/membership-privileges',
    getParentRoute: () => PhongNhaRouteRoute,
  } as any)
const PhongNhaLoyaltyIdRoute = PhongNhaLoyaltyIdRouteImport.update({
  id: '/loyalty/$id',
  path: '/loyalty/$id',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaCategoryIdRoute = PhongNhaCategoryIdRouteImport.update({
  id: '/category/$id',
  path: '/category/$id',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaAuthLoginRoute = PhongNhaAuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const LayoutStoresSelectStoreRoute = LayoutStoresSelectStoreRouteImport.update({
  id: '/stores/select-store',
  path: '/stores/select-store',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutStoresIdRoute = LayoutStoresIdRouteImport.update({
  id: '/stores/$id',
  path: '/stores/$id',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutOrdersResultRoute = LayoutOrdersResultRouteImport.update({
  id: '/orders/result',
  path: '/orders/result',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutOrdersIdRoute = LayoutOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutO2oCustomerBookTableRoute =
  LayoutO2oCustomerBookTableRouteImport.update({
    id: '/o2o/customer-book-table',
    path: '/o2o/customer-book-table',
    getParentRoute: () => LayoutRouteRoute,
  } as any)
const LayoutLoyaltyVouchersRoute = LayoutLoyaltyVouchersRouteImport.update({
  id: '/loyalty/vouchers',
  path: '/loyalty/vouchers',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutLoyaltyRewardRoute = LayoutLoyaltyRewardRouteImport.update({
  id: '/loyalty/reward',
  path: '/loyalty/reward',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutLoyaltyPointsRoute = LayoutLoyaltyPointsRouteImport.update({
  id: '/loyalty/points',
  path: '/loyalty/points',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutLoyaltyMembershipPrivilegesRoute =
  LayoutLoyaltyMembershipPrivilegesRouteImport.update({
    id: '/loyalty/membership-privileges',
    path: '/loyalty/membership-privileges',
    getParentRoute: () => LayoutRouteRoute,
  } as any)
const LayoutLoyaltyIdRoute = LayoutLoyaltyIdRouteImport.update({
  id: '/loyalty/$id',
  path: '/loyalty/$id',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCategoryIdRoute = LayoutCategoryIdRouteImport.update({
  id: '/category/$id',
  path: '/category/$id',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutAuthLoginRoute = LayoutAuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const PhongNhaGuestOrdersIndexRoute =
  PhongNhaGuestOrdersIndexRouteImport.update({
    id: '/guest/orders/',
    path: '/guest/orders/',
    getParentRoute: () => PhongNhaRouteRoute,
  } as any)
const PhongNhaCustomerAddressIndexRoute =
  PhongNhaCustomerAddressIndexRouteImport.update({
    id: '/customer/address/',
    path: '/customer/address/',
    getParentRoute: () => PhongNhaRouteRoute,
  } as any)
const LayoutGuestOrdersIndexRoute = LayoutGuestOrdersIndexRouteImport.update({
  id: '/guest/orders/',
  path: '/guest/orders/',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCustomerAddressIndexRoute =
  LayoutCustomerAddressIndexRouteImport.update({
    id: '/customer/address/',
    path: '/customer/address/',
    getParentRoute: () => LayoutRouteRoute,
  } as any)
const PhongNhaGuestOrdersResultRoute =
  PhongNhaGuestOrdersResultRouteImport.update({
    id: '/guest/orders/result',
    path: '/guest/orders/result',
    getParentRoute: () => PhongNhaRouteRoute,
  } as any)
const PhongNhaGuestOrdersIdRoute = PhongNhaGuestOrdersIdRouteImport.update({
  id: '/guest/orders/$id',
  path: '/guest/orders/$id',
  getParentRoute: () => PhongNhaRouteRoute,
} as any)
const PhongNhaCustomerAddressCreateRoute =
  PhongNhaCustomerAddressCreateRouteImport.update({
    id: '/customer/address/create',
    path: '/customer/address/create',
    getParentRoute: () => PhongNhaRouteRoute,
  } as any)
const LayoutGuestOrdersResultRoute = LayoutGuestOrdersResultRouteImport.update({
  id: '/guest/orders/result',
  path: '/guest/orders/result',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutGuestOrdersIdRoute = LayoutGuestOrdersIdRouteImport.update({
  id: '/guest/orders/$id',
  path: '/guest/orders/$id',
  getParentRoute: () => LayoutRouteRoute,
} as any)
const LayoutCustomerAddressCreateRoute =
  LayoutCustomerAddressCreateRouteImport.update({
    id: '/customer/address/create',
    path: '/customer/address/create',
    getParentRoute: () => LayoutRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/phong-nha': typeof PhongNhaRouteRouteWithChildren
  '/checkout': typeof LayoutCheckoutRoute
  '/search': typeof LayoutSearchRoute
  '/select-train': typeof LayoutSelectTrainRoute
  '/phong-nha/checkout': typeof PhongNhaCheckoutRoute
  '/phong-nha/search': typeof PhongNhaSearchRoute
  '/phong-nha/': typeof PhongNhaIndexRoute
  '/auth/login': typeof LayoutAuthLoginRoute
  '/category/$id': typeof LayoutCategoryIdRoute
  '/loyalty/$id': typeof LayoutLoyaltyIdRoute
  '/loyalty/membership-privileges': typeof LayoutLoyaltyMembershipPrivilegesRoute
  '/loyalty/points': typeof LayoutLoyaltyPointsRoute
  '/loyalty/reward': typeof LayoutLoyaltyRewardRoute
  '/loyalty/vouchers': typeof LayoutLoyaltyVouchersRoute
  '/o2o/customer-book-table': typeof LayoutO2oCustomerBookTableRoute
  '/orders/$id': typeof LayoutOrdersIdRoute
  '/orders/result': typeof LayoutOrdersResultRoute
  '/stores/$id': typeof LayoutStoresIdRoute
  '/stores/select-store': typeof LayoutStoresSelectStoreRoute
  '/phong-nha/auth/login': typeof PhongNhaAuthLoginRoute
  '/phong-nha/category/$id': typeof PhongNhaCategoryIdRoute
  '/phong-nha/loyalty/$id': typeof PhongNhaLoyaltyIdRoute
  '/phong-nha/loyalty/membership-privileges': typeof PhongNhaLoyaltyMembershipPrivilegesRoute
  '/phong-nha/loyalty/points': typeof PhongNhaLoyaltyPointsRoute
  '/phong-nha/loyalty/reward': typeof PhongNhaLoyaltyRewardRoute
  '/phong-nha/loyalty/vouchers': typeof PhongNhaLoyaltyVouchersRoute
  '/phong-nha/o2o/customer-book-table': typeof PhongNhaO2oCustomerBookTableRoute
  '/phong-nha/orders/$id': typeof PhongNhaOrdersIdRoute
  '/phong-nha/orders/result': typeof PhongNhaOrdersResultRoute
  '/auth/': typeof LayoutAuthIndexRoute
  '/category/': typeof LayoutCategoryIndexRoute
  '/customer/': typeof LayoutCustomerIndexRoute
  '/loyalty/': typeof LayoutLoyaltyIndexRoute
  '/orders/': typeof LayoutOrdersIndexRoute
  '/phong-nha/auth/': typeof PhongNhaAuthIndexRoute
  '/phong-nha/category/': typeof PhongNhaCategoryIndexRoute
  '/phong-nha/customer/': typeof PhongNhaCustomerIndexRoute
  '/phong-nha/loyalty/': typeof PhongNhaLoyaltyIndexRoute
  '/phong-nha/orders/': typeof PhongNhaOrdersIndexRoute
  '/phong-nha/qua-luu-niem/': typeof PhongNhaQuaLuuNiemIndexRoute
  '/phong-nha/thue-ao-dai/': typeof PhongNhaThueAoDaiIndexRoute
  '/customer/address/create': typeof LayoutCustomerAddressCreateRoute
  '/guest/orders/$id': typeof LayoutGuestOrdersIdRoute
  '/guest/orders/result': typeof LayoutGuestOrdersResultRoute
  '/phong-nha/customer/address/create': typeof PhongNhaCustomerAddressCreateRoute
  '/phong-nha/guest/orders/$id': typeof PhongNhaGuestOrdersIdRoute
  '/phong-nha/guest/orders/result': typeof PhongNhaGuestOrdersResultRoute
  '/customer/address/': typeof LayoutCustomerAddressIndexRoute
  '/guest/orders/': typeof LayoutGuestOrdersIndexRoute
  '/phong-nha/customer/address/': typeof PhongNhaCustomerAddressIndexRoute
  '/phong-nha/guest/orders/': typeof PhongNhaGuestOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/checkout': typeof LayoutCheckoutRoute
  '/search': typeof LayoutSearchRoute
  '/select-train': typeof LayoutSelectTrainRoute
  '/phong-nha/checkout': typeof PhongNhaCheckoutRoute
  '/phong-nha/search': typeof PhongNhaSearchRoute
  '/': typeof LayoutIndexRoute
  '/phong-nha': typeof PhongNhaIndexRoute
  '/auth/login': typeof LayoutAuthLoginRoute
  '/category/$id': typeof LayoutCategoryIdRoute
  '/loyalty/$id': typeof LayoutLoyaltyIdRoute
  '/loyalty/membership-privileges': typeof LayoutLoyaltyMembershipPrivilegesRoute
  '/loyalty/points': typeof LayoutLoyaltyPointsRoute
  '/loyalty/reward': typeof LayoutLoyaltyRewardRoute
  '/loyalty/vouchers': typeof LayoutLoyaltyVouchersRoute
  '/o2o/customer-book-table': typeof LayoutO2oCustomerBookTableRoute
  '/orders/$id': typeof LayoutOrdersIdRoute
  '/orders/result': typeof LayoutOrdersResultRoute
  '/stores/$id': typeof LayoutStoresIdRoute
  '/stores/select-store': typeof LayoutStoresSelectStoreRoute
  '/phong-nha/auth/login': typeof PhongNhaAuthLoginRoute
  '/phong-nha/category/$id': typeof PhongNhaCategoryIdRoute
  '/phong-nha/loyalty/$id': typeof PhongNhaLoyaltyIdRoute
  '/phong-nha/loyalty/membership-privileges': typeof PhongNhaLoyaltyMembershipPrivilegesRoute
  '/phong-nha/loyalty/points': typeof PhongNhaLoyaltyPointsRoute
  '/phong-nha/loyalty/reward': typeof PhongNhaLoyaltyRewardRoute
  '/phong-nha/loyalty/vouchers': typeof PhongNhaLoyaltyVouchersRoute
  '/phong-nha/o2o/customer-book-table': typeof PhongNhaO2oCustomerBookTableRoute
  '/phong-nha/orders/$id': typeof PhongNhaOrdersIdRoute
  '/phong-nha/orders/result': typeof PhongNhaOrdersResultRoute
  '/auth': typeof LayoutAuthIndexRoute
  '/category': typeof LayoutCategoryIndexRoute
  '/customer': typeof LayoutCustomerIndexRoute
  '/loyalty': typeof LayoutLoyaltyIndexRoute
  '/orders': typeof LayoutOrdersIndexRoute
  '/phong-nha/auth': typeof PhongNhaAuthIndexRoute
  '/phong-nha/category': typeof PhongNhaCategoryIndexRoute
  '/phong-nha/customer': typeof PhongNhaCustomerIndexRoute
  '/phong-nha/loyalty': typeof PhongNhaLoyaltyIndexRoute
  '/phong-nha/orders': typeof PhongNhaOrdersIndexRoute
  '/phong-nha/qua-luu-niem': typeof PhongNhaQuaLuuNiemIndexRoute
  '/phong-nha/thue-ao-dai': typeof PhongNhaThueAoDaiIndexRoute
  '/customer/address/create': typeof LayoutCustomerAddressCreateRoute
  '/guest/orders/$id': typeof LayoutGuestOrdersIdRoute
  '/guest/orders/result': typeof LayoutGuestOrdersResultRoute
  '/phong-nha/customer/address/create': typeof PhongNhaCustomerAddressCreateRoute
  '/phong-nha/guest/orders/$id': typeof PhongNhaGuestOrdersIdRoute
  '/phong-nha/guest/orders/result': typeof PhongNhaGuestOrdersResultRoute
  '/customer/address': typeof LayoutCustomerAddressIndexRoute
  '/guest/orders': typeof LayoutGuestOrdersIndexRoute
  '/phong-nha/customer/address': typeof PhongNhaCustomerAddressIndexRoute
  '/phong-nha/guest/orders': typeof PhongNhaGuestOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteRouteWithChildren
  '/phong-nha': typeof PhongNhaRouteRouteWithChildren
  '/_layout/checkout': typeof LayoutCheckoutRoute
  '/_layout/search': typeof LayoutSearchRoute
  '/_layout/select-train': typeof LayoutSelectTrainRoute
  '/phong-nha/checkout': typeof PhongNhaCheckoutRoute
  '/phong-nha/search': typeof PhongNhaSearchRoute
  '/_layout/': typeof LayoutIndexRoute
  '/phong-nha/': typeof PhongNhaIndexRoute
  '/_layout/auth/login': typeof LayoutAuthLoginRoute
  '/_layout/category/$id': typeof LayoutCategoryIdRoute
  '/_layout/loyalty/$id': typeof LayoutLoyaltyIdRoute
  '/_layout/loyalty/membership-privileges': typeof LayoutLoyaltyMembershipPrivilegesRoute
  '/_layout/loyalty/points': typeof LayoutLoyaltyPointsRoute
  '/_layout/loyalty/reward': typeof LayoutLoyaltyRewardRoute
  '/_layout/loyalty/vouchers': typeof LayoutLoyaltyVouchersRoute
  '/_layout/o2o/customer-book-table': typeof LayoutO2oCustomerBookTableRoute
  '/_layout/orders/$id': typeof LayoutOrdersIdRoute
  '/_layout/orders/result': typeof LayoutOrdersResultRoute
  '/_layout/stores/$id': typeof LayoutStoresIdRoute
  '/_layout/stores/select-store': typeof LayoutStoresSelectStoreRoute
  '/phong-nha/auth/login': typeof PhongNhaAuthLoginRoute
  '/phong-nha/category/$id': typeof PhongNhaCategoryIdRoute
  '/phong-nha/loyalty/$id': typeof PhongNhaLoyaltyIdRoute
  '/phong-nha/loyalty/membership-privileges': typeof PhongNhaLoyaltyMembershipPrivilegesRoute
  '/phong-nha/loyalty/points': typeof PhongNhaLoyaltyPointsRoute
  '/phong-nha/loyalty/reward': typeof PhongNhaLoyaltyRewardRoute
  '/phong-nha/loyalty/vouchers': typeof PhongNhaLoyaltyVouchersRoute
  '/phong-nha/o2o/customer-book-table': typeof PhongNhaO2oCustomerBookTableRoute
  '/phong-nha/orders/$id': typeof PhongNhaOrdersIdRoute
  '/phong-nha/orders/result': typeof PhongNhaOrdersResultRoute
  '/_layout/auth/': typeof LayoutAuthIndexRoute
  '/_layout/category/': typeof LayoutCategoryIndexRoute
  '/_layout/customer/': typeof LayoutCustomerIndexRoute
  '/_layout/loyalty/': typeof LayoutLoyaltyIndexRoute
  '/_layout/orders/': typeof LayoutOrdersIndexRoute
  '/phong-nha/auth/': typeof PhongNhaAuthIndexRoute
  '/phong-nha/category/': typeof PhongNhaCategoryIndexRoute
  '/phong-nha/customer/': typeof PhongNhaCustomerIndexRoute
  '/phong-nha/loyalty/': typeof PhongNhaLoyaltyIndexRoute
  '/phong-nha/orders/': typeof PhongNhaOrdersIndexRoute
  '/phong-nha/qua-luu-niem/': typeof PhongNhaQuaLuuNiemIndexRoute
  '/phong-nha/thue-ao-dai/': typeof PhongNhaThueAoDaiIndexRoute
  '/_layout/customer/address/create': typeof LayoutCustomerAddressCreateRoute
  '/_layout/guest/orders/$id': typeof LayoutGuestOrdersIdRoute
  '/_layout/guest/orders/result': typeof LayoutGuestOrdersResultRoute
  '/phong-nha/customer/address/create': typeof PhongNhaCustomerAddressCreateRoute
  '/phong-nha/guest/orders/$id': typeof PhongNhaGuestOrdersIdRoute
  '/phong-nha/guest/orders/result': typeof PhongNhaGuestOrdersResultRoute
  '/_layout/customer/address/': typeof LayoutCustomerAddressIndexRoute
  '/_layout/guest/orders/': typeof LayoutGuestOrdersIndexRoute
  '/phong-nha/customer/address/': typeof PhongNhaCustomerAddressIndexRoute
  '/phong-nha/guest/orders/': typeof PhongNhaGuestOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/phong-nha'
    | '/checkout'
    | '/search'
    | '/select-train'
    | '/phong-nha/checkout'
    | '/phong-nha/search'
    | '/phong-nha/'
    | '/auth/login'
    | '/category/$id'
    | '/loyalty/$id'
    | '/loyalty/membership-privileges'
    | '/loyalty/points'
    | '/loyalty/reward'
    | '/loyalty/vouchers'
    | '/o2o/customer-book-table'
    | '/orders/$id'
    | '/orders/result'
    | '/stores/$id'
    | '/stores/select-store'
    | '/phong-nha/auth/login'
    | '/phong-nha/category/$id'
    | '/phong-nha/loyalty/$id'
    | '/phong-nha/loyalty/membership-privileges'
    | '/phong-nha/loyalty/points'
    | '/phong-nha/loyalty/reward'
    | '/phong-nha/loyalty/vouchers'
    | '/phong-nha/o2o/customer-book-table'
    | '/phong-nha/orders/$id'
    | '/phong-nha/orders/result'
    | '/auth/'
    | '/category/'
    | '/customer/'
    | '/loyalty/'
    | '/orders/'
    | '/phong-nha/auth/'
    | '/phong-nha/category/'
    | '/phong-nha/customer/'
    | '/phong-nha/loyalty/'
    | '/phong-nha/orders/'
    | '/phong-nha/qua-luu-niem/'
    | '/phong-nha/thue-ao-dai/'
    | '/customer/address/create'
    | '/guest/orders/$id'
    | '/guest/orders/result'
    | '/phong-nha/customer/address/create'
    | '/phong-nha/guest/orders/$id'
    | '/phong-nha/guest/orders/result'
    | '/customer/address/'
    | '/guest/orders/'
    | '/phong-nha/customer/address/'
    | '/phong-nha/guest/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/checkout'
    | '/search'
    | '/select-train'
    | '/phong-nha/checkout'
    | '/phong-nha/search'
    | '/'
    | '/phong-nha'
    | '/auth/login'
    | '/category/$id'
    | '/loyalty/$id'
    | '/loyalty/membership-privileges'
    | '/loyalty/points'
    | '/loyalty/reward'
    | '/loyalty/vouchers'
    | '/o2o/customer-book-table'
    | '/orders/$id'
    | '/orders/result'
    | '/stores/$id'
    | '/stores/select-store'
    | '/phong-nha/auth/login'
    | '/phong-nha/category/$id'
    | '/phong-nha/loyalty/$id'
    | '/phong-nha/loyalty/membership-privileges'
    | '/phong-nha/loyalty/points'
    | '/phong-nha/loyalty/reward'
    | '/phong-nha/loyalty/vouchers'
    | '/phong-nha/o2o/customer-book-table'
    | '/phong-nha/orders/$id'
    | '/phong-nha/orders/result'
    | '/auth'
    | '/category'
    | '/customer'
    | '/loyalty'
    | '/orders'
    | '/phong-nha/auth'
    | '/phong-nha/category'
    | '/phong-nha/customer'
    | '/phong-nha/loyalty'
    | '/phong-nha/orders'
    | '/phong-nha/qua-luu-niem'
    | '/phong-nha/thue-ao-dai'
    | '/customer/address/create'
    | '/guest/orders/$id'
    | '/guest/orders/result'
    | '/phong-nha/customer/address/create'
    | '/phong-nha/guest/orders/$id'
    | '/phong-nha/guest/orders/result'
    | '/customer/address'
    | '/guest/orders'
    | '/phong-nha/customer/address'
    | '/phong-nha/guest/orders'
  id:
    | '__root__'
    | '/_layout'
    | '/phong-nha'
    | '/_layout/checkout'
    | '/_layout/search'
    | '/_layout/select-train'
    | '/phong-nha/checkout'
    | '/phong-nha/search'
    | '/_layout/'
    | '/phong-nha/'
    | '/_layout/auth/login'
    | '/_layout/category/$id'
    | '/_layout/loyalty/$id'
    | '/_layout/loyalty/membership-privileges'
    | '/_layout/loyalty/points'
    | '/_layout/loyalty/reward'
    | '/_layout/loyalty/vouchers'
    | '/_layout/o2o/customer-book-table'
    | '/_layout/orders/$id'
    | '/_layout/orders/result'
    | '/_layout/stores/$id'
    | '/_layout/stores/select-store'
    | '/phong-nha/auth/login'
    | '/phong-nha/category/$id'
    | '/phong-nha/loyalty/$id'
    | '/phong-nha/loyalty/membership-privileges'
    | '/phong-nha/loyalty/points'
    | '/phong-nha/loyalty/reward'
    | '/phong-nha/loyalty/vouchers'
    | '/phong-nha/o2o/customer-book-table'
    | '/phong-nha/orders/$id'
    | '/phong-nha/orders/result'
    | '/_layout/auth/'
    | '/_layout/category/'
    | '/_layout/customer/'
    | '/_layout/loyalty/'
    | '/_layout/orders/'
    | '/phong-nha/auth/'
    | '/phong-nha/category/'
    | '/phong-nha/customer/'
    | '/phong-nha/loyalty/'
    | '/phong-nha/orders/'
    | '/phong-nha/qua-luu-niem/'
    | '/phong-nha/thue-ao-dai/'
    | '/_layout/customer/address/create'
    | '/_layout/guest/orders/$id'
    | '/_layout/guest/orders/result'
    | '/phong-nha/customer/address/create'
    | '/phong-nha/guest/orders/$id'
    | '/phong-nha/guest/orders/result'
    | '/_layout/customer/address/'
    | '/_layout/guest/orders/'
    | '/phong-nha/customer/address/'
    | '/phong-nha/guest/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRouteRoute: typeof LayoutRouteRouteWithChildren
  PhongNhaRouteRoute: typeof PhongNhaRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/phong-nha': {
      id: '/phong-nha'
      path: '/phong-nha'
      fullPath: '/phong-nha'
      preLoaderRoute: typeof PhongNhaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phong-nha/': {
      id: '/phong-nha/'
      path: '/'
      fullPath: '/phong-nha/'
      preLoaderRoute: typeof PhongNhaIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/phong-nha/search': {
      id: '/phong-nha/search'
      path: '/search'
      fullPath: '/phong-nha/search'
      preLoaderRoute: typeof PhongNhaSearchRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/checkout': {
      id: '/phong-nha/checkout'
      path: '/checkout'
      fullPath: '/phong-nha/checkout'
      preLoaderRoute: typeof PhongNhaCheckoutRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/_layout/select-train': {
      id: '/_layout/select-train'
      path: '/select-train'
      fullPath: '/select-train'
      preLoaderRoute: typeof LayoutSelectTrainRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/search': {
      id: '/_layout/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof LayoutSearchRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/checkout': {
      id: '/_layout/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof LayoutCheckoutRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/phong-nha/thue-ao-dai/': {
      id: '/phong-nha/thue-ao-dai/'
      path: '/thue-ao-dai'
      fullPath: '/phong-nha/thue-ao-dai/'
      preLoaderRoute: typeof PhongNhaThueAoDaiIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/qua-luu-niem/': {
      id: '/phong-nha/qua-luu-niem/'
      path: '/qua-luu-niem'
      fullPath: '/phong-nha/qua-luu-niem/'
      preLoaderRoute: typeof PhongNhaQuaLuuNiemIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/orders/': {
      id: '/phong-nha/orders/'
      path: '/orders'
      fullPath: '/phong-nha/orders/'
      preLoaderRoute: typeof PhongNhaOrdersIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/loyalty/': {
      id: '/phong-nha/loyalty/'
      path: '/loyalty'
      fullPath: '/phong-nha/loyalty/'
      preLoaderRoute: typeof PhongNhaLoyaltyIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/customer/': {
      id: '/phong-nha/customer/'
      path: '/customer'
      fullPath: '/phong-nha/customer/'
      preLoaderRoute: typeof PhongNhaCustomerIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/category/': {
      id: '/phong-nha/category/'
      path: '/category'
      fullPath: '/phong-nha/category/'
      preLoaderRoute: typeof PhongNhaCategoryIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/auth/': {
      id: '/phong-nha/auth/'
      path: '/auth'
      fullPath: '/phong-nha/auth/'
      preLoaderRoute: typeof PhongNhaAuthIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/_layout/orders/': {
      id: '/_layout/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof LayoutOrdersIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/loyalty/': {
      id: '/_layout/loyalty/'
      path: '/loyalty'
      fullPath: '/loyalty/'
      preLoaderRoute: typeof LayoutLoyaltyIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/customer/': {
      id: '/_layout/customer/'
      path: '/customer'
      fullPath: '/customer/'
      preLoaderRoute: typeof LayoutCustomerIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/category/': {
      id: '/_layout/category/'
      path: '/category'
      fullPath: '/category/'
      preLoaderRoute: typeof LayoutCategoryIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/auth/': {
      id: '/_layout/auth/'
      path: '/auth'
      fullPath: '/auth/'
      preLoaderRoute: typeof LayoutAuthIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/phong-nha/orders/result': {
      id: '/phong-nha/orders/result'
      path: '/orders/result'
      fullPath: '/phong-nha/orders/result'
      preLoaderRoute: typeof PhongNhaOrdersResultRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/orders/$id': {
      id: '/phong-nha/orders/$id'
      path: '/orders/$id'
      fullPath: '/phong-nha/orders/$id'
      preLoaderRoute: typeof PhongNhaOrdersIdRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/o2o/customer-book-table': {
      id: '/phong-nha/o2o/customer-book-table'
      path: '/o2o/customer-book-table'
      fullPath: '/phong-nha/o2o/customer-book-table'
      preLoaderRoute: typeof PhongNhaO2oCustomerBookTableRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/loyalty/vouchers': {
      id: '/phong-nha/loyalty/vouchers'
      path: '/loyalty/vouchers'
      fullPath: '/phong-nha/loyalty/vouchers'
      preLoaderRoute: typeof PhongNhaLoyaltyVouchersRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/loyalty/reward': {
      id: '/phong-nha/loyalty/reward'
      path: '/loyalty/reward'
      fullPath: '/phong-nha/loyalty/reward'
      preLoaderRoute: typeof PhongNhaLoyaltyRewardRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/loyalty/points': {
      id: '/phong-nha/loyalty/points'
      path: '/loyalty/points'
      fullPath: '/phong-nha/loyalty/points'
      preLoaderRoute: typeof PhongNhaLoyaltyPointsRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/loyalty/membership-privileges': {
      id: '/phong-nha/loyalty/membership-privileges'
      path: '/loyalty/membership-privileges'
      fullPath: '/phong-nha/loyalty/membership-privileges'
      preLoaderRoute: typeof PhongNhaLoyaltyMembershipPrivilegesRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/loyalty/$id': {
      id: '/phong-nha/loyalty/$id'
      path: '/loyalty/$id'
      fullPath: '/phong-nha/loyalty/$id'
      preLoaderRoute: typeof PhongNhaLoyaltyIdRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/category/$id': {
      id: '/phong-nha/category/$id'
      path: '/category/$id'
      fullPath: '/phong-nha/category/$id'
      preLoaderRoute: typeof PhongNhaCategoryIdRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/auth/login': {
      id: '/phong-nha/auth/login'
      path: '/auth/login'
      fullPath: '/phong-nha/auth/login'
      preLoaderRoute: typeof PhongNhaAuthLoginRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/_layout/stores/select-store': {
      id: '/_layout/stores/select-store'
      path: '/stores/select-store'
      fullPath: '/stores/select-store'
      preLoaderRoute: typeof LayoutStoresSelectStoreRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/stores/$id': {
      id: '/_layout/stores/$id'
      path: '/stores/$id'
      fullPath: '/stores/$id'
      preLoaderRoute: typeof LayoutStoresIdRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/orders/result': {
      id: '/_layout/orders/result'
      path: '/orders/result'
      fullPath: '/orders/result'
      preLoaderRoute: typeof LayoutOrdersResultRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/orders/$id': {
      id: '/_layout/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof LayoutOrdersIdRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/o2o/customer-book-table': {
      id: '/_layout/o2o/customer-book-table'
      path: '/o2o/customer-book-table'
      fullPath: '/o2o/customer-book-table'
      preLoaderRoute: typeof LayoutO2oCustomerBookTableRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/loyalty/vouchers': {
      id: '/_layout/loyalty/vouchers'
      path: '/loyalty/vouchers'
      fullPath: '/loyalty/vouchers'
      preLoaderRoute: typeof LayoutLoyaltyVouchersRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/loyalty/reward': {
      id: '/_layout/loyalty/reward'
      path: '/loyalty/reward'
      fullPath: '/loyalty/reward'
      preLoaderRoute: typeof LayoutLoyaltyRewardRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/loyalty/points': {
      id: '/_layout/loyalty/points'
      path: '/loyalty/points'
      fullPath: '/loyalty/points'
      preLoaderRoute: typeof LayoutLoyaltyPointsRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/loyalty/membership-privileges': {
      id: '/_layout/loyalty/membership-privileges'
      path: '/loyalty/membership-privileges'
      fullPath: '/loyalty/membership-privileges'
      preLoaderRoute: typeof LayoutLoyaltyMembershipPrivilegesRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/loyalty/$id': {
      id: '/_layout/loyalty/$id'
      path: '/loyalty/$id'
      fullPath: '/loyalty/$id'
      preLoaderRoute: typeof LayoutLoyaltyIdRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/category/$id': {
      id: '/_layout/category/$id'
      path: '/category/$id'
      fullPath: '/category/$id'
      preLoaderRoute: typeof LayoutCategoryIdRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/auth/login': {
      id: '/_layout/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof LayoutAuthLoginRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/phong-nha/guest/orders/': {
      id: '/phong-nha/guest/orders/'
      path: '/guest/orders'
      fullPath: '/phong-nha/guest/orders/'
      preLoaderRoute: typeof PhongNhaGuestOrdersIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/customer/address/': {
      id: '/phong-nha/customer/address/'
      path: '/customer/address'
      fullPath: '/phong-nha/customer/address/'
      preLoaderRoute: typeof PhongNhaCustomerAddressIndexRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/_layout/guest/orders/': {
      id: '/_layout/guest/orders/'
      path: '/guest/orders'
      fullPath: '/guest/orders/'
      preLoaderRoute: typeof LayoutGuestOrdersIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/customer/address/': {
      id: '/_layout/customer/address/'
      path: '/customer/address'
      fullPath: '/customer/address/'
      preLoaderRoute: typeof LayoutCustomerAddressIndexRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/phong-nha/guest/orders/result': {
      id: '/phong-nha/guest/orders/result'
      path: '/guest/orders/result'
      fullPath: '/phong-nha/guest/orders/result'
      preLoaderRoute: typeof PhongNhaGuestOrdersResultRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/guest/orders/$id': {
      id: '/phong-nha/guest/orders/$id'
      path: '/guest/orders/$id'
      fullPath: '/phong-nha/guest/orders/$id'
      preLoaderRoute: typeof PhongNhaGuestOrdersIdRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/phong-nha/customer/address/create': {
      id: '/phong-nha/customer/address/create'
      path: '/customer/address/create'
      fullPath: '/phong-nha/customer/address/create'
      preLoaderRoute: typeof PhongNhaCustomerAddressCreateRouteImport
      parentRoute: typeof PhongNhaRouteRoute
    }
    '/_layout/guest/orders/result': {
      id: '/_layout/guest/orders/result'
      path: '/guest/orders/result'
      fullPath: '/guest/orders/result'
      preLoaderRoute: typeof LayoutGuestOrdersResultRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/guest/orders/$id': {
      id: '/_layout/guest/orders/$id'
      path: '/guest/orders/$id'
      fullPath: '/guest/orders/$id'
      preLoaderRoute: typeof LayoutGuestOrdersIdRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
    '/_layout/customer/address/create': {
      id: '/_layout/customer/address/create'
      path: '/customer/address/create'
      fullPath: '/customer/address/create'
      preLoaderRoute: typeof LayoutCustomerAddressCreateRouteImport
      parentRoute: typeof LayoutRouteRoute
    }
  }
}

interface LayoutRouteRouteChildren {
  LayoutCheckoutRoute: typeof LayoutCheckoutRoute
  LayoutSearchRoute: typeof LayoutSearchRoute
  LayoutSelectTrainRoute: typeof LayoutSelectTrainRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutAuthLoginRoute: typeof LayoutAuthLoginRoute
  LayoutCategoryIdRoute: typeof LayoutCategoryIdRoute
  LayoutLoyaltyIdRoute: typeof LayoutLoyaltyIdRoute
  LayoutLoyaltyMembershipPrivilegesRoute: typeof LayoutLoyaltyMembershipPrivilegesRoute
  LayoutLoyaltyPointsRoute: typeof LayoutLoyaltyPointsRoute
  LayoutLoyaltyRewardRoute: typeof LayoutLoyaltyRewardRoute
  LayoutLoyaltyVouchersRoute: typeof LayoutLoyaltyVouchersRoute
  LayoutO2oCustomerBookTableRoute: typeof LayoutO2oCustomerBookTableRoute
  LayoutOrdersIdRoute: typeof LayoutOrdersIdRoute
  LayoutOrdersResultRoute: typeof LayoutOrdersResultRoute
  LayoutStoresIdRoute: typeof LayoutStoresIdRoute
  LayoutStoresSelectStoreRoute: typeof LayoutStoresSelectStoreRoute
  LayoutAuthIndexRoute: typeof LayoutAuthIndexRoute
  LayoutCategoryIndexRoute: typeof LayoutCategoryIndexRoute
  LayoutCustomerIndexRoute: typeof LayoutCustomerIndexRoute
  LayoutLoyaltyIndexRoute: typeof LayoutLoyaltyIndexRoute
  LayoutOrdersIndexRoute: typeof LayoutOrdersIndexRoute
  LayoutCustomerAddressCreateRoute: typeof LayoutCustomerAddressCreateRoute
  LayoutGuestOrdersIdRoute: typeof LayoutGuestOrdersIdRoute
  LayoutGuestOrdersResultRoute: typeof LayoutGuestOrdersResultRoute
  LayoutCustomerAddressIndexRoute: typeof LayoutCustomerAddressIndexRoute
  LayoutGuestOrdersIndexRoute: typeof LayoutGuestOrdersIndexRoute
}

const LayoutRouteRouteChildren: LayoutRouteRouteChildren = {
  LayoutCheckoutRoute: LayoutCheckoutRoute,
  LayoutSearchRoute: LayoutSearchRoute,
  LayoutSelectTrainRoute: LayoutSelectTrainRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutAuthLoginRoute: LayoutAuthLoginRoute,
  LayoutCategoryIdRoute: LayoutCategoryIdRoute,
  LayoutLoyaltyIdRoute: LayoutLoyaltyIdRoute,
  LayoutLoyaltyMembershipPrivilegesRoute:
    LayoutLoyaltyMembershipPrivilegesRoute,
  LayoutLoyaltyPointsRoute: LayoutLoyaltyPointsRoute,
  LayoutLoyaltyRewardRoute: LayoutLoyaltyRewardRoute,
  LayoutLoyaltyVouchersRoute: LayoutLoyaltyVouchersRoute,
  LayoutO2oCustomerBookTableRoute: LayoutO2oCustomerBookTableRoute,
  LayoutOrdersIdRoute: LayoutOrdersIdRoute,
  LayoutOrdersResultRoute: LayoutOrdersResultRoute,
  LayoutStoresIdRoute: LayoutStoresIdRoute,
  LayoutStoresSelectStoreRoute: LayoutStoresSelectStoreRoute,
  LayoutAuthIndexRoute: LayoutAuthIndexRoute,
  LayoutCategoryIndexRoute: LayoutCategoryIndexRoute,
  LayoutCustomerIndexRoute: LayoutCustomerIndexRoute,
  LayoutLoyaltyIndexRoute: LayoutLoyaltyIndexRoute,
  LayoutOrdersIndexRoute: LayoutOrdersIndexRoute,
  LayoutCustomerAddressCreateRoute: LayoutCustomerAddressCreateRoute,
  LayoutGuestOrdersIdRoute: LayoutGuestOrdersIdRoute,
  LayoutGuestOrdersResultRoute: LayoutGuestOrdersResultRoute,
  LayoutCustomerAddressIndexRoute: LayoutCustomerAddressIndexRoute,
  LayoutGuestOrdersIndexRoute: LayoutGuestOrdersIndexRoute,
}

const LayoutRouteRouteWithChildren = LayoutRouteRoute._addFileChildren(
  LayoutRouteRouteChildren,
)

interface PhongNhaRouteRouteChildren {
  PhongNhaCheckoutRoute: typeof PhongNhaCheckoutRoute
  PhongNhaSearchRoute: typeof PhongNhaSearchRoute
  PhongNhaIndexRoute: typeof PhongNhaIndexRoute
  PhongNhaAuthLoginRoute: typeof PhongNhaAuthLoginRoute
  PhongNhaCategoryIdRoute: typeof PhongNhaCategoryIdRoute
  PhongNhaLoyaltyIdRoute: typeof PhongNhaLoyaltyIdRoute
  PhongNhaLoyaltyMembershipPrivilegesRoute: typeof PhongNhaLoyaltyMembershipPrivilegesRoute
  PhongNhaLoyaltyPointsRoute: typeof PhongNhaLoyaltyPointsRoute
  PhongNhaLoyaltyRewardRoute: typeof PhongNhaLoyaltyRewardRoute
  PhongNhaLoyaltyVouchersRoute: typeof PhongNhaLoyaltyVouchersRoute
  PhongNhaO2oCustomerBookTableRoute: typeof PhongNhaO2oCustomerBookTableRoute
  PhongNhaOrdersIdRoute: typeof PhongNhaOrdersIdRoute
  PhongNhaOrdersResultRoute: typeof PhongNhaOrdersResultRoute
  PhongNhaAuthIndexRoute: typeof PhongNhaAuthIndexRoute
  PhongNhaCategoryIndexRoute: typeof PhongNhaCategoryIndexRoute
  PhongNhaCustomerIndexRoute: typeof PhongNhaCustomerIndexRoute
  PhongNhaLoyaltyIndexRoute: typeof PhongNhaLoyaltyIndexRoute
  PhongNhaOrdersIndexRoute: typeof PhongNhaOrdersIndexRoute
  PhongNhaQuaLuuNiemIndexRoute: typeof PhongNhaQuaLuuNiemIndexRoute
  PhongNhaThueAoDaiIndexRoute: typeof PhongNhaThueAoDaiIndexRoute
  PhongNhaCustomerAddressCreateRoute: typeof PhongNhaCustomerAddressCreateRoute
  PhongNhaGuestOrdersIdRoute: typeof PhongNhaGuestOrdersIdRoute
  PhongNhaGuestOrdersResultRoute: typeof PhongNhaGuestOrdersResultRoute
  PhongNhaCustomerAddressIndexRoute: typeof PhongNhaCustomerAddressIndexRoute
  PhongNhaGuestOrdersIndexRoute: typeof PhongNhaGuestOrdersIndexRoute
}

const PhongNhaRouteRouteChildren: PhongNhaRouteRouteChildren = {
  PhongNhaCheckoutRoute: PhongNhaCheckoutRoute,
  PhongNhaSearchRoute: PhongNhaSearchRoute,
  PhongNhaIndexRoute: PhongNhaIndexRoute,
  PhongNhaAuthLoginRoute: PhongNhaAuthLoginRoute,
  PhongNhaCategoryIdRoute: PhongNhaCategoryIdRoute,
  PhongNhaLoyaltyIdRoute: PhongNhaLoyaltyIdRoute,
  PhongNhaLoyaltyMembershipPrivilegesRoute:
    PhongNhaLoyaltyMembershipPrivilegesRoute,
  PhongNhaLoyaltyPointsRoute: PhongNhaLoyaltyPointsRoute,
  PhongNhaLoyaltyRewardRoute: PhongNhaLoyaltyRewardRoute,
  PhongNhaLoyaltyVouchersRoute: PhongNhaLoyaltyVouchersRoute,
  PhongNhaO2oCustomerBookTableRoute: PhongNhaO2oCustomerBookTableRoute,
  PhongNhaOrdersIdRoute: PhongNhaOrdersIdRoute,
  PhongNhaOrdersResultRoute: PhongNhaOrdersResultRoute,
  PhongNhaAuthIndexRoute: PhongNhaAuthIndexRoute,
  PhongNhaCategoryIndexRoute: PhongNhaCategoryIndexRoute,
  PhongNhaCustomerIndexRoute: PhongNhaCustomerIndexRoute,
  PhongNhaLoyaltyIndexRoute: PhongNhaLoyaltyIndexRoute,
  PhongNhaOrdersIndexRoute: PhongNhaOrdersIndexRoute,
  PhongNhaQuaLuuNiemIndexRoute: PhongNhaQuaLuuNiemIndexRoute,
  PhongNhaThueAoDaiIndexRoute: PhongNhaThueAoDaiIndexRoute,
  PhongNhaCustomerAddressCreateRoute: PhongNhaCustomerAddressCreateRoute,
  PhongNhaGuestOrdersIdRoute: PhongNhaGuestOrdersIdRoute,
  PhongNhaGuestOrdersResultRoute: PhongNhaGuestOrdersResultRoute,
  PhongNhaCustomerAddressIndexRoute: PhongNhaCustomerAddressIndexRoute,
  PhongNhaGuestOrdersIndexRoute: PhongNhaGuestOrdersIndexRoute,
}

const PhongNhaRouteRouteWithChildren = PhongNhaRouteRoute._addFileChildren(
  PhongNhaRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LayoutRouteRoute: LayoutRouteRouteWithChildren,
  PhongNhaRouteRoute: PhongNhaRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
